import { h } from 'preact';
import { useState } from 'preact/hooks';

import IconChat from 'utils/icon/icon-chat.svg';
import IconMail from 'utils/icon/icon-mail.svg';
import IconPhone from 'utils/icon/icon-phone.svg';

import Accordion from '../utils/accordion';

const FaqSection = ({ data }) => {
  const [openedIndex, setOpenedIndex] = useState(null);

  const handleAccordeonToggle = (index) => {
    if(openedIndex === null) {
      setOpenedIndex(index);
      return;
    }

    if(openedIndex === index) {
      setOpenedIndex(null);
      return;
    }

    setOpenedIndex(index);
  };

  const renderForm = () => (
    data.form.isShow && (
      <div className="contact-us text-center md:text-left w-full bg-grey-FA p-[20px]">
        {data.form.eyebrow && (
          <div className="body-xs uppercase tracking-[2px] font-semibold">
            {data.form.eyebrow}
          </div>
        )}

        {data.form.subhead && (
          <div className="body-xs text-grey-5C font-normal mb-[10px]">
            {data.form.subhead}
          </div>
        )}

        <ul className="flex justify-center md:justify-start">
          {data.form.phoneNumber && (
            <li className="flex items-center mr-[15px] xl:mr-[40px] flex-col lg:flex-row">
              <div className="min-w-[30px]">
                <IconPhone />
              </div>

              <a className="text-center relative hover:before:hidden no-underline ml-[10px] xl:ml-[5px] font-semibold uppercase tracking-[1px] utility-xs after:content-[''] after:bg-current after:absolute after:-bottom-[3px] after:w-full after:left-0 after:h-[1px]" href={`tel:+${data.form.phoneNumber}`}>Call us</a>
            </li>
          )}

          {data.form.email && (
            <li className="flex items-center  mr-[15px] xl:mr-[40px] flex-col lg:flex-row">
              <div className="min-w-[30px]">
                <IconMail />
              </div>

              <a className="text-center relative hover:before:hidden no-underline ml-[5px] font-semibold uppercase tracking-[1px] utility-xs after:content-[''] after:bg-current after:absolute after:-bottom-[3px] after:w-full after:left-0 after:h-[1px]" href={`mailto:${data.form.phoneNumber}`}>Email us</a>
            </li>
          )}

          {data.form.isEnableChat && (
            <li className="flex items-center  mr-[15px] xl:mr-[40px] flex-col lg:flex-row">
              <div className="min-w-[30px]">
                <IconChat />
              </div>

              <a className="text-center relative hover:before:hidden no-underline ml-[5px] font-semibold uppercase tracking-[1px] utility-xs after:content-[''] after:bg-current after:absolute after:-bottom-[3px] after:w-full after:left-0 after:h-[1px]" href="/">Chat with us</a>
            </li>
          )}
        </ul>
      </div>
    )
  );

  return (
    <div className="container py-[40px] lg:py-[60px] mx-auto">
      <div className="flex flex-col md:flex-row">
        <div className="w-full md:w-5/12">
          <div className="mb-[30px] text-center md:text-left">
            <div className="h5 px-[5px] md:px-0 md:h4 text-supergoop-blue mb-[7px]">
              {data.title}
            </div>
            <div className="body-lg font-light text-grey-2A">
              {data.subtitle}
            </div>
          </div>

          <div className="hidden md:block">
            {renderForm()}
          </div>
        </div>

        {data.accordiones.length > 0 && (
          <div className="question-block w-full md:w-7/12 md:pl-[30px] xl:pl-[80px]">
            <div className="border-b border-grey-D0">
              {data.accordiones.map((accordion, index) => (
                <Accordion
                  className="border-b border-grey-D0"
                  key={accordion.id}
                  title={accordion.title}
                  content={accordion.overview}
                  openedIndex={openedIndex}
                  toggleAccordeon={handleAccordeonToggle}
                  isGeneric={false}
                  index={index}
                  classes={{
                    accordion: 'py-[12px] border-grey-D0 border-t',
                    title:
                      'w-[calc(100%-25px)] body md:body-md md:subheading-base leading-5 text-4 text-grey-2A',
                    content:
                      'overflow-hidden max-h-[0px] transition-all laptop:px-0',
                  }}
                />
              ))}
            </div>
          </div>
        )}

        <div className="block md:hidden mt-[20px] md:max-lg:bg-red-600">
          {renderForm()}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;